import { useEffect } from 'react';

import type { RulesRedirectPageProps } from './RulesRedirectPage.types';

export const RulesRedirectPage = ({ redirectUrl }: RulesRedirectPageProps) => {
    useEffect(() => {
        // Перенаправляем напрямую на PDF
        window.location.href = redirectUrl;
    }, [redirectUrl]);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#666',
            }}
        >
            Открываем правила...
        </div>
    );
};
